import type { AdminUserSearchResultDto } from '@up2stay/up2promo-api-client';

import { getAbsoluteFileUrl } from '@/core/lib/file-url';

export function adminUserAvatarUrl(
  user: AdminUserSearchResultDto,
): string | null {
  const path = user.photo?.path?.trim();
  if (!path) return null;
  return getAbsoluteFileUrl(path);
}

export function adminUserInitials(user: AdminUserSearchResultDto): string {
  const label = user.displayName?.trim() || user.email || user.username || '';
  if (!label) return '?';
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
  }
  return label.slice(0, 2).toUpperCase();
}
